
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

parcelRegister("lW4bD", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", function () { return $ff82431dc1dc3028$export$bdfd709ae4826697; }, function (v) { return $ff82431dc1dc3028$export$bdfd709ae4826697 = v; });
// TODO: convert this file to ESM once HMR issues are resolved
var $ff82431dc1dc3028$export$5a759dc7a1cfb72a;
var $ff82431dc1dc3028$export$bdfd709ae4826697;
var $ff82431dc1dc3028$export$c9e73fbda7da57b6;
"use strict";
const $ff82431dc1dc3028$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $ff82431dc1dc3028$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $ff82431dc1dc3028$var$getBundleURLCached(id, inputError) {
    let value = $ff82431dc1dc3028$var$bundleURL[id];
    if (!value) {
        value = $ff82431dc1dc3028$var$getBundleURL(inputError);
        $ff82431dc1dc3028$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $ff82431dc1dc3028$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $ff82431dc1dc3028$var$getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($ff82431dc1dc3028$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff82431dc1dc3028$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $ff82431dc1dc3028$var$getOrigin(url) {
    return new URL(url).origin;
}
$ff82431dc1dc3028$export$5a759dc7a1cfb72a = $ff82431dc1dc3028$var$getOrigin;
$ff82431dc1dc3028$export$bdfd709ae4826697 = $ff82431dc1dc3028$var$getBundleURLCached;
$ff82431dc1dc3028$export$c9e73fbda7da57b6 = $ff82431dc1dc3028$var$getBaseURL;

});

var $c38a721562c294b4$exports = {};


(parcelRequire("hwrhg")).register((parcelRequire("lW4bD")).getBundleURL('4kTQ1'), JSON.parse("[\"4kTQ1\",\"404.248fa3c4.js\",\"9BftR\",\"create-payload.b71770b3.js\",\"lM1L3\",\"create-post-interaction-log-payload.cab2160f.js\",\"knVBe\",\"segment-highlight.251f1805.js\",\"hyT2F\",\"dropdown-import.a5f6f8ff.js\",\"PtGJI\",\"dropdown-import.ea6c509e.js\",\"b8kt6\",\"esm.bfad249a.js\",\"ak5E0\",\"dev.83f2cda9.js\",\"1UKEw\",\"view.995c076b.js\",\"7Q4ht\",\"view.4e28631d.js\",\"gFcxC\",\"view.8e10e432.js\",\"9WEDO\",\"view.d38315f2.js\",\"h62UC\",\"language-selector.fd1724c4.js\",\"evwwy\",\"language-selector.19a3adf4.js\",\"8QhO3\",\"app-switcher.7d685a79.js\",\"32DAP\",\"segment-highlight.84b39bae.js\",\"78ssC\",\"robot-error.552736fc.js\",\"3sxEO\",\"atlassian-switcher.494280c0.js\",\"jj9yd\",\"cs.7b234aca.js\",\"1JUTQ\",\"da.62618ad7.js\",\"eJY2b\",\"de.46672041.js\",\"boveV\",\"en_GB.6766e0b7.js\",\"jhzZD\",\"en_ZZ.af139930.js\",\"3ggHc\",\"en.87a2d9b0.js\",\"6K3IJ\",\"es.4c4eba58.js\",\"2Egxk\",\"et.3caf19cd.js\",\"jrBrI\",\"fi.8d605e3a.js\",\"ke1AQ\",\"fr.5ab9a337.js\",\"6THQG\",\"hu.9a8ef4dd.js\",\"h42BO\",\"is.f2eb1909.js\",\"7ineD\",\"it.fde3e011.js\",\"9sO7N\",\"ja.d020ac03.js\",\"lnoMs\",\"ko.c27f249a.js\",\"kVmkq\",\"nb.b371dc88.js\",\"3DibN\",\"nl.7211569b.js\",\"9Uhkl\",\"pl.ba5b7890.js\",\"8mFDW\",\"pt_BR.26da3cd7.js\",\"7GlIc\",\"pt_PT.8da2b19d.js\",\"dvqQm\",\"ro.f880e19a.js\",\"3ZtCq\",\"ru.04189acc.js\",\"dcHjQ\",\"sk.c086a826.js\",\"ajnS3\",\"sv.f4e8b4cf.js\",\"bcnO6\",\"th.422e111c.js\",\"hL42d\",\"tr.c967489f.js\",\"dr0Vi\",\"uk.6820c492.js\",\"kopRi\",\"vi.22d816cf.js\",\"dFq33\",\"zh_TW.af1bd14c.js\",\"jMVsQ\",\"zh.d6b97da9.js\",\"iJGev\",\"jira-switcher.dc370525.js\",\"9qSz3\",\"jira-switcher.7bf501af.js\",\"dRtpj\",\"animation-illustration.8496687a.js\",\"aitqo\",\"animation-illustration.a14376c8.js\",\"1az2W\",\"jira-switcher.41c8f4ed.js\",\"dvcYi\",\"jira-switcher.runtime.940d9163.js\",\"dvcYi\",\"jira-switcher.runtime.940d9163.js\",\"2BPdX\",\"confluence-switcher.7349073d.js\",\"1Cf3b\",\"generic-switcher.32e842e7.js\",\"iTD5B\",\"custom-theme.193f5d70.js\",\"42hNR\",\"atlassian-light.fced6189.js\",\"d7Q1x\",\"atlassian-light-future.5da65f54.js\",\"axYAg\",\"atlassian-light-increased-contrast.12889eb1.js\",\"dxnrk\",\"atlassian-dark.2c01fb4d.js\",\"gEsP8\",\"atlassian-dark-future.9ee88b93.js\",\"10pgT\",\"atlassian-dark-increased-contrast.fdcc0602.js\",\"fi0UL\",\"atlassian-legacy-light.c59ca21e.js\",\"f9gs0\",\"atlassian-legacy-dark.5c75743b.js\",\"6o2ay\",\"atlassian-spacing.1c6c1bb5.js\",\"fytov\",\"atlassian-typography.25060324.js\",\"adIJD\",\"atlassian-shape.36e7f70f.js\"]"));


//# sourceMappingURL=404.runtime.21a466c5.js.map
